export default __webpack_public_path__ + "static/media/pexels_diva_plavalaguna_2.004f3f18.jpg";